import { useEffect } from 'react';
import { applyTheme, useThemeStore } from '@/stores/theme';

/**
 * Keeps the `dark` class on <html> in step with the stored preference.
 *
 * Renders nothing. The FIRST application is not this component's job: the
 * inline script in index.html has already put the class on <html> before a
 * byte of React ran, because an effect fires one paint too late and a
 * dark-mode user would get a white flash on every load. This effect exists
 * for every change AFTER that - a toggle press, a Settings choice, or the
 * store rehydrating in another tab - and for re-asserting `color-scheme` and
 * `theme-color`, which the script also sets but which are cheap to repeat.
 *
 * Unlike FormDesk's there is no `matchMedia` listener here, because there is
 * no `system` preference to follow: light is the default and dark is a choice.
 */
export function ThemeProvider() {
  const pref = useThemeStore((s) => s.pref);

  useEffect(() => {
    applyTheme(pref);
  }, [pref]);

  return null;
}
